import React from "react";
import Layout from "../components/organisms/Layout";
import registerBg from "../assets/images/register_bg.jpg";
import Beneficios from "../components/atoms/BeneficiosList2";
import FormRegister from "../components/molecules/FormRegister";

const register = () => {
	return (
		<Layout landingPage={"registrama"}>
			<section
				className='user-account benefit-section register-form'
				style={{
					backgroundImage: `url(${registerBg})`,
				}}>
				<div className='container'>
					<div className='row'>
						<div className='col-md-12'>
							<h1 className='pb-2'>
								Regístrate y disfruta <br /> de todos los beneficios
							</h1>
						</div>
						<div className='col-md-12 col-lg-5 pt-5'>
							<Beneficios />
						</div>
						<div className='col-md-12 col-lg-7 pl-lg-5'>
							<FormRegister />
						</div>
					</div>
				</div>
			</section>
		</Layout>
	);
};

export default register;
